import { ObjectRuntimeState } from '../types'

/** プレイ時クリック / ホバーの命中対象となる状態か（可視・不透明・clickable）。 */
export const isClickableState = (
  state: Pick<ObjectRuntimeState, 'visible' | 'transparency' | 'clickable'>,
): boolean => state.visible && state.transparency < 1 && state.clickable
